const parseBool = (value: string): boolean =>
  value?.toLowerCase() === 'true' || value === '1';

const parseCommaSeparated = (value: string): string[] =>
  value
    ? value
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

interface AppConfig {
  apiBaseUrl: string;
  legacyUrl: string;
  apiGatewayUrl: string;
  authAdapterUrl: string;
  allowedLogoutRedirectUrls: string[];
  stripePublishKey: string;
  salesrabbitStripePublishableKey: string;
  salesrabbitConnectAccountsPublishableKey: string;
  segmentWriteKey: string;
  enableSegment: boolean;
  googleMapsApiKey: string;
  melissaApiKey: string;
  posthogApiKey: string;
  useCookieAuth: boolean;
  ipApiKey: string;
  demandUrl: string;
  salesUrl: string;
}

export const appConfig: AppConfig = {
  apiBaseUrl: '',
  legacyUrl: '',
  apiGatewayUrl: '',
  authAdapterUrl: '',
  allowedLogoutRedirectUrls: [],
  stripePublishKey: '',
  salesrabbitStripePublishableKey: '',
  salesrabbitConnectAccountsPublishableKey: '',
  segmentWriteKey: '',
  enableSegment: false,
  googleMapsApiKey: '',
  melissaApiKey: '',
  posthogApiKey: '',
  useCookieAuth: false,
  ipApiKey: '',
  demandUrl: '',
  salesUrl: '',
};

const CRITICAL_URLS = [
  'apiBaseUrl',
  'legacyUrl',
  'apiGatewayUrl',
  'authAdapterUrl',
] as const;

export async function fetchAppConfig(): Promise<void> {
  const res = await fetch('/api/environment/config');
  if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
  const data = await res.json();

  CRITICAL_URLS.forEach((key) => {
    if (!data[key]) console.warn(`${key} is not configured`);
  });

  Object.assign(appConfig, {
    apiBaseUrl: data.apiBaseUrl,
    legacyUrl: data.legacyUrl,
    apiGatewayUrl: data.apiGatewayUrl,
    authAdapterUrl: data.authAdapterUrl,
    allowedLogoutRedirectUrls: parseCommaSeparated(
      data.allowedLogoutRedirectUrls
    ),
    stripePublishKey: data.stripePublishKey,
    salesrabbitStripePublishableKey: data.salesrabbitStripePublishableKey,
    salesrabbitConnectAccountsPublishableKey:
      data.salesrabbitConnectAccountsPublishableKey,
    segmentWriteKey: data.segmentWriteKey,
    enableSegment: parseBool(data.enableSegment),
    googleMapsApiKey: data.googleMapsApiKey,
    melissaApiKey: data.melissaApiKey,
    posthogApiKey: data.posthogApiKey,
    useCookieAuth: parseBool(data.useCookieAuth),
    ipApiKey: data.ipApiKey,
    demandUrl: data.demandUrl,
    salesUrl: data.salesUrl,
  });
}
